export default function GoogleMapSection() {
  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <h2 className="font-serif text-2xl md:text-3xl font-bold text-plum-dark mb-4">
          Où nous trouver
        </h2>
        <p className="text-plum-dark text-base md:text-lg mb-8 max-w-2xl">
          Notre atelier est situé au 82 rue de Heidenberg, 67200 Strasbourg. Nous intervenons dans tout le Bas-Rhin.
        </p>
        <div className="rounded-2xl overflow-hidden border border-rose-100 aspect-[16/9] md:aspect-[21/9]">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2638.0!2d7.7350!3d48.5839!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4796c84a3c7c2e47%3A0x1c3e3e3e3e3e3e3e!2s82%20Rue%20de%20Heidenberg%2C%2067200%20Strasbourg!5e0!3m2!1sfr!2sfr!4v1700000000000!5m2!1sfr!2sfr"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Carte Google Maps - Atelier DF PRO Strasbourg"
            aria-label="Carte Google Maps montrant l'emplacement de l'atelier DF PRO à Strasbourg"
          />
        </div>

        {/* Votre commune n'est pas listée */}
        <div className="mt-12 md:mt-16 bg-white rounded-2xl border border-rose-100 p-6 md:p-10 text-center">
          <div className="w-12 h-12 rounded-xl bg-rose-50 flex items-center justify-center mx-auto mb-4">
            <i className="ri-map-2-line text-plum text-xl" />
          </div>
          <h3 className="font-serif text-xl md:text-2xl font-bold text-plum-dark mb-3">
            Votre commune n&apos;est pas listée ?
          </h3>
          <p className="text-plum-dark text-base md:text-lg max-w-2xl mx-auto mb-6">
            Nous intervenons dans tout le Bas-Rhin et dans les communes limitrophes. Appelez-nous au 03 74 47 10 36 et nous vous dirons si nous pouvons nous déplacer chez vous.
          </p>
          <a
            href="tel:0374471036"
            className="inline-flex items-center justify-center gap-2 bg-coral text-white px-8 py-4 rounded-xl font-semibold text-base whitespace-nowrap hover:bg-coral-light transition-colors"
          >
            <i className="ri-phone-line" />
            Appeler le 03 74 47 10 36
          </a>
        </div>
      </div>
    </section>
  );
}